import { useEffect, useState } from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface CatalogRenameDialogProps {
  open: boolean
  title: string
  labelSk: string
  labelEn: string
  initialSk: string
  initialEn: string
  cancelLabel: string
  saveLabel: string
  hint?: string
  pending?: boolean
  onClose: () => void
  onSave: (nameSk: string, nameEn: string) => void
}

export function CatalogRenameDialog({
  open,
  title,
  labelSk,
  labelEn,
  initialSk,
  initialEn,
  cancelLabel,
  saveLabel,
  hint,
  pending,
  onClose,
  onSave
}: CatalogRenameDialogProps) {
  const [sk, setSk] = useState(initialSk)
  const [en, setEn] = useState(initialEn)

  // Reset fields each time the dialog opens for a new target.
  useEffect(() => {
    if (open) {
      setSk(initialSk)
      setEn(initialEn)
    }
  }, [open, initialSk, initialEn])

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Label className="mb-1.5 block">{labelSk}</Label>
            <Input value={sk} onChange={(e) => setSk(e.target.value)} />
          </div>
          <div>
            <Label className="mb-1.5 block">{labelEn}</Label>
            <Input value={en} onChange={(e) => setEn(e.target.value)} />
            {hint && (
              <p className="mt-1.5 text-xs text-muted-foreground">{hint}</p>
            )}
          </div>
        </div>

        <DialogFooter>
          <Button type="button" variant="ghostDark" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button
            type="button"
            disabled={!sk.trim() || pending}
            onClick={() => onSave(sk.trim(), en.trim())}
          >
            {saveLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
